import coreStore from "./core-store";

const remoteResource = 'resource/api/v1/files';

const store = coreStore.searchQueryStore(coreStore.createCoreStore('importFileQuery', remoteResource, 'importFileQueries'))

export default store;